// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import blogdata from "../../JsonData/blogdata.json";
// import BlogFaqs from "./blogFaq";
// import Cta from "../../utils/CtaForProperties";
// import Ads from "../section-components/ads";

// const BlogDetails = () => {
//   const { slug } = useParams();
//   const [blog, setBlog] = useState(null);

//   useEffect(() => {
//     const foundBlog = blogdata.blogs.find(b => b.Slug === slug);
//     if (foundBlog?.Content && typeof foundBlog.Content === "string") {
//       try {
//         foundBlog.Content = JSON.parse(foundBlog.Content);
//       } catch {
//         console.log("Content parsing error");
//       }
//     }
//     setBlog(foundBlog);
//   }, [slug]);

//   if (!blog) return <div className="text-center py-5">Blog not found</div>;

//   const { Content, FeaturedImage, Title, publishedDate, ID } = blog;



//   return (
//     <div className="container mx-auto px-4 py-12">
//       {/* Title */}
//       <h1 className="text-3xl lg:text-5xl font-bold mb-4 text-gray-800 pd-top-90" style={{fontSize: "35px"}}>{Content?.title}</h1>
//       <h5 className="text-gray-500 mb-4 text-center" style={{ fontSize: "20px"}}>{publishedDate}</h5>

//       {/* Featured Image */}
//       {FeaturedImage && (
//         <img
//           src={FeaturedImage}
//           alt="Blog Feature"
//           className="w-full rounded-lg mb-6 object-cover max-h-[400px]"
//         />
//       )}

//       {/* Publish Date */}


//       {/* Blog Content */}
//       <div
//         className="prose prose-lg max-w-none lg:prose-xl text-gray-800"
//         dangerouslySetInnerHTML={{ __html: Content.richtext }}
//       />

//       {/* CTA */}

//       {blog.ID === 2 && <Ads />}

//       {/* FAQ Section */}
//         <BlogFaqs blogId={blog.ID} />

//     </div>
//   );
// };

// export default BlogDetails;



import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import blogdata from "../../JsonData/blogdata.json";
import BlogFaqs from "./blogFaq";
import Cta from "../../utils/CtaForProperties";
import Ads from "../section-components/ads";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const foundBlog = blogdata.blogs.find(b => b.Slug === slug);
    if (foundBlog?.Content && typeof foundBlog.Content === "string") {
      try {
        foundBlog.Content = JSON.parse(foundBlog.Content);
      } catch {
        console.log("Content parsing error");
      }
    }
    setBlog(foundBlog);
  }, [slug]);

  if (!blog) return <div className="text-center py-5">Blog not found</div>;

  const { Content, FeaturedImage, publishedDate, ID } = blog;

  return (
    <div className="container py-5">
      {/* Internal Styles */}
      <style>{`
        .blog-title {
          font-size: 35px;
          font-weight: 700;
          color: #212529;
        }

        .blog-date {
          font-size: 18px;
          color: #6c757d;
        }

        .blog-featured-img {
          max-height: 450px;
          width: 100%;
          object-fit: cover;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
          margin-bottom: 30px;
        }

        .blog-card {
          border: none;
          border-radius: 12px;
          box-shadow: 0 0 20px rgba(0,0,0,0.05);
        }

        .blog-card-body {
          padding: 30px;
        }

        .blog-content {
          font-size: 16px;
          color: #343a40;
        }

        .blog-content table {
          width: 100% !important;
          border-collapse: collapse;
          margin-top: 20px;
          margin-bottom: 20px;
        }

        .blog-content table th {
          text-align: center;
          border: 1px solid #dee2e6;
  padding: 10px;
}

.blog-content table td {
  text-align: left;
  border: 1px solid #dee2e6;
  padding: 10px;
}


        .blog-content ul,
        .blog-content ol {
          padding-left: 20px;
          list-style: none;
        }

        .blog-content h2,
        .blog-content h3,
        .blog-content h4 {
          margin-top: 1.8rem;
          color: #333;
        }
      `}</style>

      {/* Title & Date */}
      <div className="text-center mb-4">
        <h1 className="blog-title">{Content?.title}</h1>
        <p className="blog-date">{publishedDate}</p>
      </div>

      {/* Featured Image */}
      {FeaturedImage && (
        <div className="text-center">
          <img
            src={FeaturedImage}
            alt="Blog Feature"
            className="blog-featured-img"
          />
        </div>
      )}

      {/* Blog Content */}
      <div className="card blog-card mb-5">
        <div className="card-body blog-card-body">
          <div
            className="blog-content"
            dangerouslySetInnerHTML={{ __html: Content.richtext }}
          />
        </div>
      </div>

      {/* CTA Section (only for ID 2) */}
      {ID === 2 && <Ads />}

      {/* FAQ Section */}
      <BlogFaqs blogId={ID} />
    </div>
  );
};

export default BlogDetails;
